import Cookies from "js-cookie";

export function setAuthCookies(accessToken: string, imagesToken: string, rememberMe: boolean): void {
  const expires = rememberMe ? 30 : 1; // days
  Cookies.set("access_token", accessToken, { expires, path: "/", secure: true, sameSite: "none" });
  Cookies.set("images_token", imagesToken, { expires, path: "/", secure: true, sameSite: "none" });
}

export function clearAuthCookies(): void {
  Cookies.remove("access_token", { path: "/" });
  Cookies.remove("images_token", { path: "/" });
}
